module.exports = __webpack_public_path__ + "static/media/Barmag 3a2.63455593.jpg";